<script>
  import List, {Item, Meta, Label, Graphic, Separator} from '@smui/list';
  import IconButton from '@smui/icon-button';
  import Snackbar, {Label as SnackbarLabel} from '@smui/snackbar';
  import Paper from '@smui/paper';
  import AppBar from "./AppBar.svelte";
  import Password from "./Password.svelte";
  import Clipboard from 'svelte-clipboard';
	import { createEventDispatcher } from 'svelte';


  export let entries;
  export let route;

  const dispatch = createEventDispatcher();

  function getText(entry, idx) {
    copiedEntry = entry.name;
    let values = entry.values;
    if (idx == undefined) {
        idx = values.length - 1;
    }
    return values[idx].value;
  }

  let copySnackbar
  let curEntries;
  let splitRoute;
  let copiedEntry;
  $: {
      splitRoute = route ? route.split("/") : [];
      curEntries = entries;
      for (let p in splitRoute) {
        curEntries = curEntries.children[+splitRoute[p]];
      }

  }
</script>

{#key route}
<AppBar title={curEntries.name} back></AppBar>
<div class='entries-container'>
<Paper class="centered-content">
<List class="entries-list centered-content" nonInteractive={curEntries.values.length != 0}>
    {#each curEntries.children as entry, i}
    <Item on:SMUI:action={() => dispatch("navigate", [...splitRoute, i].join('/'))}>
        {#if entry.values.length > 0 }
        <Graphic class="material-icons">lock</Graphic>
        {:else}
        <Graphic class="material-icons">folder</Graphic>
        {/if}
        <Label>
            {entry.name}
        </Label>
        {#if entry.values.length > 0 }
        <Meta>
            <div on:click|stopPropagation={()=>{}}>
            <Clipboard text={() => getText(entry)} on:copy={copySnackbar.forceOpen} let:copy>
                <IconButton class="material-icons" aria-label="Copy" on:click={copy}>content_copy</IconButton>
            </Clipboard>
            </div>
        </Meta>
        {/if}
    </Item>
    <Separator />
    {/each}
    {#each curEntries.values.slice().reverse() as value, i}
    <Item>
        <Password value={value.value} label={new Date(Date.parse(value.created)).toLocaleString()}/>
        <Meta style="margin-left: 0;">
        <Clipboard text={() => getText(curEntries, curEntries.values.length - 1 - i)} on:copy={copySnackbar.forceOpen} let:copy>
            <IconButton class="material-icons" aria-label="Copy" on:click={copy}>content_copy</IconButton>
        </Clipboard>
        </Meta>
    </Item>
    <Separator />
    {/each}
</List>
</Paper>
</div>
<Snackbar bind:this={copySnackbar} labelText={copiedEntry + " copied! "}>
    <SnackbarLabel></SnackbarLabel>
</Snackbar>
{/key}

<style>
  .entries-container {
    display: block; 
    flex-direction: row; 
    justify-content: center; 
    height: 100%; 
    width: 100%;
    overflow: auto;
  }

  .entries-container :global(.centered-content) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    min-width: 250px;
    /*width: 100%;*/
  }

  .entries-container :global(.entries-list) {
    padding: 0;
    padding-top: 8px;
    margin-bottom:8px;
  }
</style>